import React from "react";

const Add = ({ className, title = "", fill = "#6D7881", onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>{title}</title>
      <desc>Created with sketchtool.</desc>
      <g
        id="Asset-Artboard-Page"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Icons/Add-04-|-🛠-|-Icons/Functional/add" fill={fill}>
          <path
            d="M12,0 C12.6624,0 13.2,0.405735849 13.2,0.905660377 L13.2,0.905660377 L13.2,10.8 L23.0943396,10.8 C23.5609358,10.8 23.9454833,11.2683093 23.9946825,11.8693063 L24,12 C24,12.6624 23.5942642,13.2 23.0943396,13.2 L23.0943396,13.2 L13.2,13.2 L13.2,23.0943396 C13.2,23.5609358 12.7316907,23.9454833 12.1306937,23.9946825 L12,24 C11.3376,24 10.8,23.5942642 10.8,23.0943396 L10.8,23.0943396 L10.8,13.199 L0.905660377,13.2 C0.439064151,13.2 0.0545167296,12.7316907 0.00531750105,12.1306937 L0,12 C0,11.3376 0.405735849,10.8 0.905660377,10.8 L0.905660377,10.8 L10.8,10.799 L10.8,0.905660377 C10.8,0.439064151 11.2683093,0.0545167296 11.8693063,0.00531750105 Z"
            id="icon-add"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default Add;
